import { render, staticRenderFns } from "./OverviewV2.vue?vue&type=template&id=9b196864&"
import script from "./OverviewV2.vue?vue&type=script&lang=js&"
export * from "./OverviewV2.vue?vue&type=script&lang=js&"
import style0 from "../overview/overview.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports